import React from 'react';
import './ChampionImageWithLevel.css';
import SimpleHealthManaBar from './SimpleHealthManaBar';

interface ChampionImageWithLevelProps {
  imageUrl: string;
  name: string;
  level: number;
}

const ChampionImageWithLevel: React.FC<ChampionImageWithLevelProps> = ({
  imageUrl,
  name,
  level,
}) => {
  return (
    <div className="champ-img-champion-image-container">
      <div className="champ-img-champion-image-level-wrapper">
        <img src={imageUrl} alt={name} className="champ-img-champion-image" />
        <div className="champ-img-champion-level">{level}</div>
      </div>
    </div>
  );
};

export default ChampionImageWithLevel;
